export const createUserModalFields = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  type: "type",
  status: "status",
} as const
